import PropTypes from 'prop-types';

import PageLoading from '@zenbusiness/zui/PageLoading';

import useFlowFormFactorConfig from '../hooks/useFlowFormFactorConfig';

function ExperimentsContent({ baseConfig, children }) {
  const { config, loading } = useFlowFormFactorConfig(baseConfig);

  // Show loading state while we wait for the correct config.
  if (loading) {
    return <PageLoading />;
  }

  return children(config);
}

ExperimentsContent.propTypes = {
  baseConfig: PropTypes.object.isRequired,
  children: PropTypes.func.isRequired
};

export default ExperimentsContent;
